module.exports = __webpack_public_path__ + "img/Send-Invite.b967ae31.svg";